import React from "react";
import { Box, Typography } from "@mui/material";
import CircularLoading from "../CircularLoading/CircularLoading";
import visuallyHiddenSx from "../../../utils/a11y/visuallyHiddenSx";
import { FONT_INTER } from "../../../styles/fonts";

// `message` is shown below the spinner; without it only screen readers get "Carregando..."
const PageLoading = ({ message }) => (
  <Box
    component="main"
    aria-busy="true"
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 3,
      minHeight: "100vh",
      backgroundColor: "#fff",
      fontFamily: FONT_INTER,
    }}
  >
    <CircularLoading size={56} />
    <Typography
      role="status"
      aria-live="polite"
      sx={
        message
          ? {
              fontFamily: FONT_INTER,
              fontSize: 20,
              fontWeight: 600,
              color: "#1D1D1F",
            }
          : visuallyHiddenSx
      }
    >
      {message || "Carregando..."}
    </Typography>
  </Box>
);

export default PageLoading;
